const TOKEN_KEY = "aria_token";
const PHONE_KEY = "aria_phone";
const USER_KEY = "aria_user_id";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function getPhone() {
  return localStorage.getItem(PHONE_KEY) || "";
}

export function getUserId() {
  return localStorage.getItem(USER_KEY) || "";
}

export function setSession({ token, phone, userId }) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (phone) localStorage.setItem(PHONE_KEY, phone);
  if (userId != null) localStorage.setItem(USER_KEY, String(userId));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(PHONE_KEY);
  localStorage.removeItem(USER_KEY);
}

function b64urlDecode(s) {
  s = String(s || "").replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  try {
    return decodeURIComponent(
      atob(s)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
  } catch (_e) {
    try {
      return atob(s);
    } catch (_e2) {
      return "";
    }
  }
}

/** True when JWT is missing/malformed or past exp (with a small skew). */
export function isTokenExpired(token = getToken()) {
  if (!token) return true;
  try {
    const parts = String(token).split(".");
    if (parts.length < 2) return true;
    const payload = JSON.parse(b64urlDecode(parts[1]) || "{}");
    if (!payload || !payload.exp) return false;
    return payload.exp * 1000 < Date.now() - 15000;
  } catch (_e) {
    return true;
  }
}

export function buildCurrentUser() {
  const token = getToken();
  const phone = getPhone();
  if (!token || isTokenExpired(token)) return null;

  // Shape compatible with old Firebase user consumers (phoneNumber, getIdToken)
  return {
    phoneNumber: phone.startsWith("0") ? `+93${phone.slice(1)}` : phone,
    localPhone: phone,
    uid: getUserId() || phone,
    getIdToken: async () => token,
  };
}
